import { Button, Row } from "antd";

type Props = {
  current: number;
  steps: Array<string>;
  next: (savedChange: boolean) => void;
  prev: () => void;
  editable?: boolean;
  onCancel?: () => void;
  cancelText?: string;
};

const MultiFormNavigation: React.FC<Props> = ({current, steps, next, prev, editable, onCancel, cancelText = "Cancelar"}) => {
  return (
    <Row style={{ marginTop: 24 }}>
      {current > 0 && (
        <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
          Voltar
        </Button>
      )}
      {current <= steps.length - 1 && (
        <Button type="primary" onClick={() => next(false)}>
          {current < steps.length - 1 ? 'Avançar': 'Salvar Cadastro'}
        </Button>
      )}
      {editable && current <= steps.length - 1 && current < steps.length - 1 && (
        <Button type="primary" onClick={() => next(true)}>
          Salvar Cadastro
        </Button>
      )}
      {onCancel && (
        <Button style={{ margin: '0 8px' }} onClick={onCancel}>
          {cancelText}
        </Button>
      )}
    </Row>
  );
}

export default MultiFormNavigation;